var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "72DA413C-0791-4F20-9AA0-86A1F56DBDF2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.011765 0 0 0 0 0.458824 0 0 0 0 0.729412 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.66896473,-8.52651283e-14 L13.4948471,5.24329415 L7.66896473,10.4865883 L6.33103527,9 L9.394,6.243 L0,6.24329415 L0,4.24329415 L9.394,4.243 L6.33103527,1.48658829 L7.66896473,-8.52651283e-14 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PN-v1.5---2.0-Register---Add-Serial---Main",
    transform: "translate(-111.000000, -194.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/UI/Arrow-Left",
    transform: "translate(106.000000, 187.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Color",
    fill: "#0375BA",
    fillRule: "nonzero",
    transform: "translate(6.747424, 5.243294) scale(-1, 1) translate(-6.747424, -5.243294) ",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-3)",
    fill: "red",
    id: "Rectangle-6-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.000000, -8.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.4ab8bc7454b265bf149124cc3cdf6895.svg";
export { ForwardRef as ReactComponent };